import React from "react";
import { FaCompass, FaCreditCard, FaGift, FaMapMarkedAlt, FaShoppingBag, FaArrowRight } from "react-icons/fa";
import CrossUniverseBridgePanel from "../components/CrossUniverseBridgePanel";

export default function ForfeoUniverseBridge() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 via-white to-blue-50">
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-4xl text-center">
          <div className="mb-5 inline-flex items-center gap-2 rounded-full bg-blue-100 px-4 py-2 text-xs font-black uppercase tracking-[0.24em] text-blue-800">
            <FaCompass /> Deux univers, une seule expérience Forfeo
          </div>
          <h1 className="text-4xl font-black tracking-tight text-slate-950 md:text-6xl">
            Découvrez sur Explore. Achetez sur Forfeo.com.
          </h1>
          <p className="mt-6 text-lg leading-8 text-slate-600">
            Forfeo relie la découverte locale, les Combos, les expériences, les cartes cadeaux,
            les paiements et les dashboards marchands dans un écosystème cohérent.
          </p>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-2">
          <div className="rounded-[2rem] border border-blue-100 bg-white p-8 shadow-xl shadow-blue-950/5">
            <FaMapMarkedAlt className="mb-5 text-4xl text-blue-600" />
            <h2 className="text-2xl font-black text-slate-950">Forfeo Explore</h2>
            <p className="mt-3 text-sm leading-6 text-slate-600">
              Découverte d’expériences, régions, Last Call, Combos Forfeo, avis clients,
              alertes intelligentes et inspiration cadeau.
            </p>
            <ul className="mt-5 space-y-3 text-sm text-slate-700">
              <li>• Découvrir le Québec et les régions</li>
              <li>• Explorer les Combos Forfeo</li>
              <li>• Recevoir des alertes intelligentes</li>
              <li>• Lire les avis et réserver des expériences</li>
            </ul>
          </div>

          <div className="rounded-[2rem] border border-indigo-100 bg-white p-8 shadow-xl shadow-indigo-950/5">
            <FaCreditCard className="mb-5 text-4xl text-indigo-600" />
            <h2 className="text-2xl font-black text-slate-950">Forfeo.com</h2>
            <p className="mt-3 text-sm leading-6 text-slate-600">
              Univers transactionnel officiel : Carte Accès Privilège Forfeo, boutique,
              paiements sécurisés, vouchers, reçus et portefeuille client.
            </p>
            <ul className="mt-5 space-y-3 text-sm text-slate-700">
              <li>• Acheter une carte Forfeo</li>
              <li>• Finaliser un achat</li>
              <li>• Recevoir ses vouchers</li>
              <li>• Gérer son portefeuille Forfeo</li>
            </ul>
          </div>
        </div>

        <div className="mt-10">
          <CrossUniverseBridgePanel context="home" />
        </div>
      </section>
    </div>
  );
}
